import api from './config'

export function sendFeedback(payload) {
  return api.post('/feedbacks/', payload);
}